import React from 'react'
import { useParams } from 'react-router-dom'
import loadComponent from 'src/utils/loadMFE'
import RouteContainer from 'src/components/App/RouteContainer'

const CompanyBranchReadOnlyForm = React.lazy(() => loadComponent('orga', 'CompanyBranchReadOnlyForm'))

export function CompanyBranchDetailsRoute() {
    const params = useParams()

    return (
        <RouteContainer>
            <CompanyBranchReadOnlyForm _id={params._id} />
        </RouteContainer>
    )
}
